import * as React from 'react';
import { SVGProps } from 'react';
const SvgDownload = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.2418 16.4073V19.7934H3.89332V16.4073H1.5V22.0508H22.5001L22.5 16.4073H20.2418Z"
      fill="current"
    />
    <path
      d="M17.3162 11.6022L15.8611 10.1471L13.1883 12.8096V2.01953H11.1243V12.8096L8.45151 10.1471L6.99643 11.6022L12.1563 16.762L17.3162 11.6022Z"
      fill="current"
    />
  </svg>
);
export default SvgDownload;
